// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --dry-bg: #fff;
    --dry-color: #000;
    --dry-border-color: #d9d9d9;
    --dry-border-width: 1px;
    --dry-border-style: solid;
    --dry-border: var(--dry-border-width) var(--dry-border-style) var(--dry-border-color);
    --dry-border-radius: .3rem;
    --dry-shadow-color: #0000001a;
    --dry-shadow-color2: #0000000f;
    --dry-shadow: var(--dry-shadow-color) 0px 4px 6px -1px, var(--dry-shadow-color2) 0px 2px 4px -1px;    
    --dry-primary: #1976d2;
    --dry-primary-text: #fff;
    --dry-primary-highlight: #E9F4FE;
    --dry-primary-highlight-text: var(--dry-primary);

    --dry-modal-fade: #00000020;
    --dry-hover-bg: #F3F4F6;
    --dry-control-bg: #fff;

    --dry-error: #FCF3F2;
    --dry-error-text: #AC352D;

    --dry-tooltip-bg: var(--dry-color);
    --dry-tooltip-color: var(--dry-bg);

    --dry-progress-color: var(--dry-primary);
    --dry-progress-bg: var(--dry-border-color);

    --dry-resizer-width: calc(var(--dry-border-width) * 2);
    --dry-resizer-color: var(--dry-border-color);

    
    --dry-modal-zindex:     1000;
    --dry-popover-zindex:  10000;
    --dry-tooltip-zindex: 100000;

    --dry-transition: .5s;
}

:is(input, textarea).dry {
    background-color: var(--dry-bg);
    border: var(--dry-border);
    border-radius: var(--dry-border-radius);
    padding: .5em .8em;
    box-sizing: border-box;
}
:is(input, textarea).dry::placeholder {
    opacity: .6;
}
:is(input, textarea).dry:focus {
    border-color: var(--dry-primary);
    outline: none !important
}
:is(input, textarea).dry.error {
    border-color: var(--dry-error-text);
}

.dry-buttons {
    display: inline-flex;
    border: var(--dry-border);
    border-radius: var(--dry-border-radius);
    & > button {
        flex: auto 1 1;
        background-color: transparent;
        border: 0;
        border-radius: 0;
        border-right: var(--dry-border);
        padding: .5em 1em;
        font-size: 1em;
        cursor: pointer;
        &:first-child {
            border-radius: var(--dry-border-radius) 0 0 var(--dry-border-radius);
        }
        &:last-child {
            border-right-color: transparent;
            border-radius: 0 var(--dry-border-radius) var(--dry-border-radius) 0;
        }
        &:hover {
            background-color: var(--dry-primary-highlight);
            color: var(--dry-primary-highlight-text);
        }
        &[data-checked="true"] {
            background-color: var(--dry-primary);
            color: var(--dry-primary-text);
            border-color: var(--dry-primary);
        }
    }
}

.dawn {
    animation: appear 0.4s linear 1;
}

@keyframes appear {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
